{
  "en": {
    "todo_v2": {
      "actions": {
        "confirm": "Mark as done",
        "create": "Task",
        "reopen": "Reopen",
        "update": "Edit task"
      },
      "assignee_types": {
        "customer": "Customer",
        "employee": "Employee",
        "partner": "Partner"
      },
      "attributes": {
        "assignees": "Assignees",
        "created_at": "Created",
        "due_date": "Due date",
        "project": "Project",
        "status": "Status",
        "todo_group": "Task",
        "unit": "Unit"
      },
      "labels": {
        "add_assignee": "Add an assignee…",
        "add_customers": "Add customers",
        "completed": "Completed",
        "confirm_message": "Are you sure you want to mark this task as done?",
        "customers": "Customers",
        "group_already_added": "This task is already added to this unit.",
        "my_todos": "My tasks",
        "no_assignees": "No assignees yet.",
        "no_todos": "No tasks yet.",
        "no_todos_group": "No tasks in this group yet.",
        "no_todos_unit": "No tasks for this unit yet.",
        "publish_all": "Publish all",
        "publish_customers": "Publish for each unit's customers",
        "published": "Published",
        "required": "This field is required",
        "select_group": "Select a task",
        "upload_hint": "Upload the requested document(s) to complete this task.",
        "uploaded_documents": "Uploaded documents"
      },
      "statuses": {
        "completed": "Completed",
        "draft": "Draft",
        "pending": "Pending"
      },
      "toasts": {
        "completed": "Task completed",
        "create": "Task created",
        "delete": "Task deleted",
        "uncompleted": "Task reopened",
        "update": "Task updated"
      }
    }
  }
}
